export default "__VITE_ASSET__BAkgnBnD__"